module.exports = __webpack_public_path__ + "static/media/manzana_big.847c6e11.png";